import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { CFontIcon } from "@appcues/component-library";
import { getThemeFor } from "utils";

const PaginationWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 30px;
`;

const PageItem = styled.button`
  background-color: ${getThemeFor("$gray-1")};
  text-align: center;
  margin: 0 2px;
  padding: 4px;
  background-color: #f5f7fa;
  display: block;
  height: auto;
  height: 30px;
  width: 30px;
  border-radius: 6px;
  border: 1px solid ${getThemeFor("$gray-1")};
  &:hover,
  &:focus {
    cursor: pointer;
    border: 1px solid ${getThemeFor("$gray-2")};
    background-color: ${getThemeFor("$gray-2")};
  }
  &.skip-button {
    background-color: transparent;
    border: none;
    &:hover,
    &:focus {
      cursor: pointer;
      border: 1px solid ${getThemeFor("$gray-2")};
      background-color: ${getThemeFor("$gray-2")};
    }
  }
  &.selected {
    color: ${getThemeFor("$blue")};
    border: 1px solid ${getThemeFor("$blue")};
    background-color: ${getThemeFor("$gray-0")};
    &:hover {
      color: ${getThemeFor("$gray-0")};
      border: 1px solid ${getThemeFor("$blue")};
      background-color: ${getThemeFor("$blue")};
    }
  }
`;

/**
 * Pagination Component
 * @params {number} pageCount - the number of total "pages"
 * @params {number} currentIndex - the current index/page as set by the parent container
 * @params {function} onChange - passes up the selected "data-index" (ie: selected page index)
 */
const Pagination = ({ pageCount = 1, currentIndex = 0, onChange }) => {
  const handleClick = ({ target }) => {
    onChange(parseInt(target.getAttribute("data-index")));
  };

  // can probably clean this up
  const pages = [];
  for (var i = 1; i <= pageCount; i++) {
    pages.push(i);
  }

  return (
    <PaginationWrapper role="navigation" aria-label="pagination navigator">
      <PageItem
        className="skip-button"
        role="button"
        tabIndex="0"
        data-index={currentIndex - 1}
        aria-label={`Go to previous page`}
        onClick={handleClick}
        disabled={currentIndex === 0}
      >
        <CFontIcon className="fa fa-chevron-left" pointerEvents="none" />
      </PageItem>
      {pages.map((omit, index) => (
        <PageItem
          className={currentIndex === index && "selected"}
          role="button"
          tabIndex="0"
          key={index}
          data-index={index}
          aria-label={`Go to Page ${index}`}
          onClick={handleClick}
        >
          {index + 1}
        </PageItem>
      ))}
      <PageItem
        className="skip-button"
        role="button"
        tabIndex="0"
        data-index={currentIndex + 1}
        aria-label={`Go to next page`}
        onClick={handleClick}
        disabled={currentIndex === pageCount - 1}
      >
        <CFontIcon className="fa fa-chevron-right" pointerEvents="none" />
      </PageItem>
    </PaginationWrapper>
  );
};

Pagination.propTypes = {
  pageCount: PropTypes.number,
  currentIndex: PropTypes.number,
  onChange: PropTypes.func.isRequired
};

export default Pagination;
